export const desktopTheme = {
  colors: {
    elevation1: '#323232',
    elevation2: '#242424',
    elevation3: '#1D1D1D',
    accent1: '#33A7FF',
    accent2: '#2475B2',
    accent3: '#3C93FF',
    highlight1: '#FFFFFF',
    highlight2: '#AAAAAA',
    highlight3: '#F1F1F1',
  },
  fontSizes: {
    root: '12px',
  },
  sizes: {
    rootWidth: '360px',
    rowHeight: '26px',
    folderTitleHeight: '26px',
  },
  fonts: {
    mono: 'Inter',
    sans: 'Inter',
  },
};

export const mobileTheme = {
  colors: {
    elevation1: '#323232AA',
    elevation2: '#24242400',
    elevation3: '#1D1D1D',
    accent1: '#33A7FF',
    accent2: '#2475B2',
    accent3: '#3C93FF',
    highlight1: '#FFFFFF',
    highlight2: '#AAAAAA',
    highlight3: '#F1F1F1',
  },
  fontSizes: {
    root: '12px',
  },
  sizes: {
    rootWidth: '360px',
    rowHeight: '26px',
    folderTitleHeight: '26px',
    controlWidth: '140px',
  },
  fonts: {
    mono: 'Inter',
    sans: 'Inter',
  },
  borderWidths: {
    folder: '0px',
  },
  space: {
    rowGap: '11px',
  },
};

export const siteRefreshTheme = {
  colors: {
    elevation1: '#2A2A2A',
    elevation2: '#141414',
    elevation3: '#000000',
    accent1: '#3084FF',
    accent2: '#3084FF',
    accent3: '#5A9DFF',
    highlight1: '#555555',
    highlight2: '#AAAAAA',
    highlight3: '#FFFFFF',
    folderWidgetColor: '#AAAAAA',
    folderTextColor: '#AAAAAA',
  },
  radii: {
    xs: '2px',
    sm: '2px',
    lg: '2px',
  },
  space: {
    rowGap: '6px',
  },
  fontSizes: {
    root: '12px',
  },
  sizes: {
    rootWidth: '360px',
    controlWidth: '170px',
    rowHeight: '32px',
    folderTitleHeight: '32px',
  },
  fonts: {
    mono: "'Inter', system-ui, sans-serif",
    sans: "'Inter', system-ui, sans-serif",
  },
};
